import React, { Fragment } from "react";
import get from "lodash/get";
import styled from "styled-components";
import Moment from "react-moment";
import { Table, TableCell, TableRow } from "./Table";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverContentItem
} from "./Popover";
import { formatPrice } from "../utils/helpers";
import { EXTERNAL_OPEN, MORE } from "../icons";
import * as colors from "../settings/colors";
import Icon from "./Icon";
import StatusLabel from "./StatusLabel";

const columnSizing = "100px 1fr 1fr 1fr 1fr 68px";

const StyledIcon = styled(Icon)`
  fill: ${colors.TAB_TEXT};

  &:hover {
    fill: ${colors.BLUE};
  }
`;

class ContractsList extends React.Component {
  handleSelection = value => {
    value();
  };

  viewAttachment(contract) {
    window.location = contract.attachment.versions.original;
  }

  renderContractLabel = (contract, isPrimary) => {
    if (contract.cancelled) {
      return <StatusLabel status="cancelled" text="Cancelled" />;
    }
    return <StatusLabel text={isPrimary ? "Initial" : "Addendum"} />;
  };

  renderContract = contract => {
    const attachmentLink = get(contract, "attachment.versions.original", null);
    const isPrimary = this.props.primaryContractId === contract.id;
    return (
      <TableRow key={contract.id} columns={columnSizing}>
        <TableCell justify="flex-end">
          {this.renderContractLabel(contract, isPrimary)}
        </TableCell>
        <TableCell>{this.props.contractType}</TableCell>
        <TableCell>
          <Moment format="MMM D, YYYY" utc>
            {contract.effectiveDate}
          </Moment>
        </TableCell>
        <TableCell>{contract.description}</TableCell>
        <TableCell justify="flex-end">
          {formatPrice(contract.amountInCents)}
        </TableCell>
        <TableCell justify="flex-end">
          {attachmentLink && (
            <a href={attachmentLink} target="_blank" style={{ marginRight: 4 }}>
              <StyledIcon icon={EXTERNAL_OPEN} />
            </a>
          )}
          <Popover onSelection={this.handleSelection}>
            <PopoverTrigger>
              <StyledIcon icon={MORE} />
            </PopoverTrigger>
            <PopoverContent>
              {!contract.cancelled ? (
                <Fragment>
                  <PopoverContentItem
                    value={() => this.props.editContract(contract)}
                  >
                    Edit contract
                  </PopoverContentItem>
                  {!isPrimary && (
                    <PopoverContentItem
                      value={() => this.props.setAsPrimaryContract(contract)}
                    >
                      Set as initial contract
                    </PopoverContentItem>
                  )}
                  <PopoverContentItem
                    value={() => this.props.cancelContract(contract)}
                    color={colors.RED}
                  >
                    Cancel contract
                  </PopoverContentItem>
                </Fragment>
              ) : (
                <Fragment>
                  <PopoverContentItem
                    value={() => this.props.uncancelContract(contract)}
                  >
                    Uncancel Contract
                  </PopoverContentItem>
                </Fragment>
              )}
            </PopoverContent>
          </Popover>
        </TableCell>
      </TableRow>
    );
  };

  render() {
    const contracts = [...this.props.contracts];

    contracts.sort((a, b) => {
      if (this.props.primaryContractId === a.id) {
        return -1;
      } else if (this.props.primaryContractId === b.id) {
        return 1;
      } else {
        return a.id - b.id;
      }
    });

    return (
      <Table>
        <TableRow header columns={columnSizing}>
          <TableCell />
          <TableCell>Type</TableCell>
          <TableCell>Effective Date</TableCell>
          <TableCell>Description</TableCell>
          <TableCell justify="flex-end">Amount</TableCell>
          <TableCell />
        </TableRow>
        {contracts.map(this.renderContract)}
      </Table>
    );
  }
}

export default ContractsList;



// WEBPACK FOOTER //
// ./src/components/ContractsList.js